import { createFileRoute } from "@tanstack/react-router";

import CompetitionTools from "../../../../components/CompetitionTools/CompetitionTools";

const Component = () => {
  const { competitionUuid } = Route.useParams();
  return <CompetitionTools competitionUuid={competitionUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/tools")({
  component: Component,
});
